import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StockThresholdsPanel"},[_c('div',{staticClass:"stpTitle"},[_vm._v(_vm._s(_vm.$t('stockPage.lists.sectionTitle')))]),(!_vm.stock)?_c(VSkeletonLoader,{attrs:{"type":"image"}}):_vm._e(),_vm._l((_vm.stockThresholds),function(e,i){return _c('div',{key:i,staticClass:"threshold"},[_c('StockThresholdPanel',{attrs:{"stock":e}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }